import { useParams, useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useSession } from '@/hooks/authHooks';

// Used to wrap the SignIn Page
export function RedirectIfAuthenticated({
  children,
}: {
  children: React.ReactNode;
}) {
  const { session, isPending } = useSession();
  const router = useRouter();

  const authFlow = useParams({
    from: '/auth/$authFlow',
    select: (params) => params.authFlow,
  });

  useEffect(() => {
    if (!isPending && session) {
      router.navigate({ to: '/' });
    }
  }, [isPending, session, router, authFlow]);

  if (isPending) return null;
  return children;
}
